// Client-side mirrors of the backend's permission gates (src/app/api/pos/route.js
// in the ordering repo). Admins pass every check by role, as they do there.

export const userCan = (user, permission) => user?.role === 'admin' || Boolean(user?.permissions?.includes(permission));
export const userCanAny = (user, permissions) => permissions.some((permission) => userCan(user, permission));

// The backend's per-resource gates. Requests a login fails these are refused
// with 403, so the POS skips them instead of showing the refusal as a sync error.
export const ORDER_WRITE_PERMISSIONS = ['pos', 'queue', 'kitchen', 'riders'];
export const RIDER_READ_PERMISSIONS = ['riders', 'pos', 'kitchen'];
export const INVENTORY_PERMISSIONS = ['inventory', 'pos'];

// Admins read the full ledger; staff read (and submit) only through My Expenses.
export const canReadExpenses = (user) => user?.role === 'admin' || Boolean(user?.permissions?.includes('myexpenses'));

// Whether this login may upload a queued record of the given kind. The upload
// queues belong to the tablet, not to whoever is signed in, so a record one
// person saved can come up for retry under someone who may not write it.
export const canUploadQueued = (user, kind) => {
  if (!user) return false;
  if (kind === 'orders') return userCanAny(user, ORDER_WRITE_PERMISSIONS);
  if (kind === 'inventory') return userCanAny(user, INVENTORY_PERMISSIONS);
  if (kind === 'expenses') return canReadExpenses(user);
  return false;
};

// Only supervisors ('amend') and admins may amend an order, and the backend
// refuses the save from anyone else.
export const canAmendOrders = (user) => userCan(user, 'amend');

// Expenses, profit and the analytics dashboard: owner-level reporting.
export const canViewFinancialReports = (user) => userCan(user, 'analytics');

// The sales-only End-of-Day tab is for staff given 'eod' explicitly. Anyone
// with analytics already opens the full report from the Analytics tab.
export const canViewEodSales = (user) => Boolean(user?.permissions?.includes('eod')) && !canViewFinancialReports(user);

export const canUseMarketing = (user) => userCan(user, 'marketing');

// Campaign spend and revenue impact stay with the owner.
export const canViewMarketingResults = (user) => user?.role === 'admin';
